import PropTypes from 'prop-types';
import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Progress, Row, Col } from 'reactstrap';
import Badge from './badge';
import MetricCard from './metricCard';

// Quality Agent Completion Modal - shows Executive Summary after run completes
const QualityAgentCompletionModal = _ref => {
  var _summary$assessment;
  let isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    _ref$summary = _ref.summary,
    summary = _ref$summary === void 0 ? {} : _ref$summary;
  const passRate = summary.totalChecks > 0 ? Math.round(summary.passed / summary.totalChecks * 100) : 0;

  // Get assessment color - matches prior runs modal logic
  const getAssessmentColor = assessment => {
    if (!assessment) return 'secondary';
    if (assessment === 'passed' || assessment === 'good' || assessment === 'all_good') return 'success';
    if (assessment === 'needs_attention' || assessment === 'warning') return 'warning';
    return 'danger';
  };

  // Format assessment for display
  const assessmentDisplay = ((_summary$assessment = summary.assessment) === null || _summary$assessment === void 0 ? void 0 : _summary$assessment.replace(/_/g, ' ')) || 'Complete';
  const assessmentColor = getAssessmentColor(summary.assessment);
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    toggle: onClose,
    size: "lg"
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    toggle: onClose
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      marginRight: 12
    }
  }, "Quality Agent Analysis Complete"), /*#__PURE__*/React.createElement(Badge, {
    color: assessmentColor,
    pill: true,
    style: {
      padding: '4px 12px'
    },
    className: "text-capitalize"
  }, assessmentDisplay)), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement("p", {
    className: "text-muted mb-4",
    style: {
      lineHeight: 1.7,
      fontSize: '1.1rem'
    }
  }, summary.assessmentMessage || 'Analysis complete.'), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Row, {
    className: "g-3 mb-4"
  }, /*#__PURE__*/React.createElement(Col, {
    xs: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(MetricCard, {
    title: "Total Checks",
    value: summary.totalChecks
  })), /*#__PURE__*/React.createElement(Col, {
    xs: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(MetricCard, {
    title: "Passed",
    value: summary.passed,
    color: "success"
  })), /*#__PURE__*/React.createElement(Col, {
    xs: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(MetricCard, {
    title: "Failed",
    value: summary.failed,
    color: "danger"
  })), /*#__PURE__*/React.createElement(Col, {
    xs: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(MetricCard, {
    title: "Warnings",
    value: summary.warnings,
    color: "warning"
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between small mb-1"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-muted"
  }, "Overall pass rate"), /*#__PURE__*/React.createElement("span", {
    className: "fw-medium"
  }, passRate, "%")), /*#__PURE__*/React.createElement(Progress, {
    value: passRate,
    color: (() => {
      if (passRate >= 80) return 'success';
      if (passRate >= 50) return 'warning';
      return 'danger';
    })(),
    style: {
      height: 8
    }
  }))), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    onClick: onClose
  }, "View Details")));
};
QualityAgentCompletionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  summary: PropTypes.shape({
    assessment: PropTypes.string,
    assessmentMessage: PropTypes.string,
    totalChecks: PropTypes.number,
    passed: PropTypes.number,
    failed: PropTypes.number,
    warnings: PropTypes.number
  })
};

// Removed defaultProps - using default parameters in function signature instead

export default QualityAgentCompletionModal;